import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import dataCenterHero from "../assets/Hero/data-hero.avif"; // Replace with your hero image
import dataCenterImage from "../assets/Hero/data-center.jpg"; // Replace with your data center image
import dataCenterDenefitsImage from "../assets/Hero/datacenteimg.webp"
import featuresImage from "../assets/Hero/Nairobi.jpg"; // Replace with your features image
import "../assets/css/dataCenterSolutionsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const dataCenterData = {
  hero: {
    title: "Data Center Solutions",
    subtitle: "Optimizing Your Data Center for Performance and Efficiency",
  },
  introduction: {
    heading: "Why Data Center Solutions Matter",
    paragraphs: [
      "A well-designed and managed data center is critical for ensuring business continuity, scalability, and security in today's digital landscape.",
      "Our data center solutions are tailored to meet your unique needs, providing robust infrastructure, energy efficiency, and seamless scalability.",
    ],
  },
  features: {
    heading: "Our Data Center Solutions Features",
    items: [
      "Custom Data Center Design & Build",
      "High-Density Server Solutions",
      "Energy-Efficient Cooling Systems",
      "Disaster Recovery & Redundancy",
      "24/7 Monitoring & Support",
      "Cloud Integration & Hybrid Solutions",
    ],
  },
  benefits: {
    heading: "Benefits of Our Solutions",
    items: [
      {
        icon: "fa fa-server",
        text: "Enhanced performance and reliability for critical operations.",
      },
      {
        icon: "fa fa-bolt",
        text: "Energy-efficient solutions to reduce operational costs.",
      },
      {
        icon: "fa fa-shield",
        text: "Robust security measures to protect your data.",
      },
      {
        icon: "fa fa-line-chart",
        text: "Scalable infrastructure to support business growth.",
      },
      {
        icon: "fa fa-check-circle",
        text: "Compliance with industry standards and regulations.",
      },
    ],
  },
  cta: {
    heading: "Ready to Optimize Your Data Center?",
    text: "Contact us today to learn more about our Data Center Solutions and how we can help transform your infrastructure.",
  },
};

export const DataCenterSolutionsPage = ({ data }) => {
  const dataCenterRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = dataCenterRef.current.querySelectorAll(".data-center-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: dataCenterRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="data-center-page" ref={dataCenterRef}>
      {/* Hero Section */}
      <div
        className="data-center-hero-section"
        style={{ backgroundImage: `url(${dataCenterHero})` }}
      >
        <h1 className="data-center-animate">{dataCenterData.hero.title}</h1>
        <p className="data-center-animate">{dataCenterData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container data-center-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="data-center-animate">{dataCenterData.introduction.heading}</h2>
            {dataCenterData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="data-center-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 data-center-image-container">
            <img
              src={dataCenterImage}
              className="img-fluid data-center-animate"
              alt="Data Center Solutions"
            />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container data-center-features">
        <div className="row">
          <div className="col-md-6 data-center-image-container">
            <img
              src={dataCenterDenefitsImage}
              className="img-fluid data-center-animate"
              alt="Data Center Features"
              style={{ maxWidth: "100%" }}
            />
          </div>
          <div className="col-md-6">
            <h2 className="data-center-animate">{dataCenterData.features.heading}</h2>
            <ul>
              {dataCenterData.features.items.map((item, index) => (
                <li key={index} className="data-center-animate">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div
        className="container-fluid data-center-benefits"
        style={{ backgroundImage: `url(${featuresImage})` }}
      >
        <div className="overlay">
          <h2 className="data-center-animate">{dataCenterData.benefits.heading}</h2>
          <div className="benefits-cards">
            {dataCenterData.benefits.items.map((item, index) => (
              <div key={index} className="benefit-card data-center-animate">
                <i className={item.icon}></i>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container data-center-cta">
        <h2 className="data-center-animate">{dataCenterData.cta.heading}</h2>
        <p className="data-center-animate">{dataCenterData.cta.text}</p>
        <button
          className="btn btn-primary data-center-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};